import React, { useEffect, useState } from 'react';
import { fetchBirthdayCelebrants } from '@/services/api';
import { motion } from 'framer-motion';

const BirthdayCelebrants = () => {
    const [celebrants, setCelebrants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getCelebrants = async () => {
            try {
                const response = await fetchBirthdayCelebrants();
                setCelebrants(response.data);
            } catch (err) {
                console.error(err);
                setError('Failed to load birthday celebrants.');
            } finally {
                setLoading(false);
            }
        };

        getCelebrants();
    }, []);

    if (loading || celebrants.length === 0) return null;

    return (
        <section className="py-12 bg-gradient-to-br from-pink-100 via-rose-50 to-purple-100">
            <div className="max-w-6xl mx-auto px-6">
                {/* Banner */}
                <motion.h2
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center text-3xl md:text-4xl font-extrabold text-purple-800 mb-10"
                >
                    🎂 Celebrating Today’s Birthdays 🎉
                </motion.h2>

                {/* Cards */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {celebrants.map((person, index) => (
                        <motion.div
                            key={person.id}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="bg-white rounded-xl shadow-md border border-purple-200 hover:shadow-lg transition-all duration-300"
                        >
                            <div className="p-5 flex items-center gap-4">
                                <img
                                    src={person.photo || '/avatar-placeholder.png'}
                                    alt={person.name}
                                    className="w-16 h-16 object-cover rounded-full border-2 border-purple-400 shadow-sm"
                                />
                                <div>
                                    <h4 className="text-lg font-semibold text-purple-900 leading-tight">
                                        {person.title} {person.name}
                                    </h4>
                                    <p className="text-sm text-gray-600 mt-1">
                                        🎈 {new Date(person.dob).toLocaleDateString(undefined, {
                                            month: 'long',
                                            day: 'numeric',
                                        })}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Optional error */}
                {error && (
                    <p className="mt-6 text-center text-red-500 text-sm">{error}</p>
                )}
            </div>
        </section>
    );
};

export default BirthdayCelebrants;
